export default [
    {
        path: '/eventTypes',
        name: 'eventTypes',
        component: () => import ('./pages/EventTypeRegister')
    },
]